module.exports = "./img/7a27034fec3f88b5d7f3feebc1527b09.png";